import CommonService from "@/services/common.service";

export const decodeUrlMixin = {
  methods: {
    decodedUrl(encodedUrl: string) {
      try {
        return CommonService.safeDecodeURIComponent(encodedUrl).replace(/\/\/$/, "/");
      } catch (e) {
        return encodedUrl;
      }
    },

    layoutDefaultColor() {
      return "#1C76D2";
    },
  },
};
